/**
 * common functions for animation
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


const STANDARD_ANIMATION_DURATION = 0.7;


export function getStandardAnimate() {
    return [
        {opacity: 0, y: "-7vw"},
        {opacity: 1, y:  "0vw"},
        {opacity: 0, y:  "7vw"}
    ];
}

export function getBottomAnimate() {
    return [
        {opacity: 0, y:  "7vw"},
        {opacity: 1, y:  "0vw"},
        {opacity: 0, y:  "7vw"}
    ];
}

export function getHorizontalAnimate() {
    return [
        {opacity: 0, x:  "12vw", y:  "0vw"},
        {opacity: 1, x:   "0vw", y:  "0vw"},
        {opacity: 0, x: "-12vw", y:  "0vw"},
        {opacity: 0, x:   "0vw", y: "-7vw"}
    ];
}

export function getStandardTransition(delay, pause = 1) {
    return [
        {
            ease: "easeOut",
            duration: STANDARD_ANIMATION_DURATION,
            delay: (delay + pause) * STANDARD_ANIMATION_DURATION
        },
        {
            ease: "easeIn",
            duration: STANDARD_ANIMATION_DURATION,
            delay: delay * STANDARD_ANIMATION_DURATION
        }
    ]
}
